import keyMirror from 'keymirror';

export default keyMirror({
  GBUTTON_CLICKED: null,
  GBUTTON_CLICKED_ERROR: null,
  GAPI_INITIALIZED: null,
  GAPI_INITIALIZED_ERROR: null
});
